import Icon from '../components/Icon.vue'

Icon.register({
  stamp: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M32 512v-64h448v64h-448zM416 256c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32h-448c-17.7 0-32-14.3-32-32v-32c0-53 43-96 96-96h66.6c16.3 0 29.4-13.2 29.4-29.4v-0.1c0-31.8-10-62.1-23.3-90.9-5.6-12-8.7-25.4-8.7-39.6 0-58.7 52.6-105 113.3-94.5 38.8 6.8 70.5 38.7 77.3 77.5 3.9 22 0.1 42.8-9 60.4-12.6 24.3-21.5 50.4-21.5 77.7v9.5c0 16.3 13.2 29.4 29.4 29.4h66.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/stamp.js
// module id = 1941
// module chunks = 0